import { business } from "@icabbi/api-gateway-client";
import apiInstance from "@/helpers/apiInstance";

const defaultState = {
  businessUserServiceClient: null,
};

const getters = {
  businessUserServiceClient:
    (state, getters, rootState, rootGetters) =>
    ({ dispatch }) => {
      if (!state.businessUserServiceClient) {
        state.businessUserServiceClient = apiInstance({
          dispatch,
          getters: rootGetters,
          Connector: business.BusinessUserServiceConnector,
        });
      }
      return state.businessUserServiceClient;
    },
};

/**
 * @params {ID} id
 * @returns {UserApoDto} user - src/core/api/users/UserApiDto.ts
 */
async function fetchUserById(context, id) {
  const businessUserServiceClient =
    context.getters.businessUserServiceClient(context);

  return await businessUserServiceClient.getUserById(id);
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions: {
    fetchUserById,
  },
}